//Imports
import React, { useCallback, useEffect } from "react";

//Controls
import { Button, Modal } from "@gpstrackit/gtc-react-controls";

//Components
import { NotificationManager, NotificationContainer } from "Components/Notifications";

//Hooks
import { useIntl } from "react-intl";

//Actions
import { manageDeleteManageDriverStates, reset } from "./redux/slice";
import { useDispatch, useSelector } from "react-redux";

const DeleteManageDriverStatus = ({ callback }) => {
  //Redux
  const dispatch = useDispatch();
  const { open, loading, result, error, deleteDriverStatus, deleteDriverStatusList } = useSelector(
    (state) => state.manageDeleteManageDriverStatusRedux
  );

  //Language
  const { messages } = useIntl();

  //Handlers and utils
  const handleClose = useCallback(() => dispatch(reset()), []);

  const handleDeleteSubmit = useCallback(() => {
    if (deleteDriverStatus) {
      dispatch(manageDeleteManageDriverStates({ ids: [deleteDriverStatus?.id] }));
      return;
    }
    if (deleteDriverStatusList?.length) {
      dispatch(manageDeleteManageDriverStates({ ids: deleteDriverStatusList.map(driverStatus => driverStatus.id) }));
    }
  }, [deleteDriverStatus, deleteDriverStatusList]);

  //Effects
  useEffect(() => {
    if (!error) return;
    NotificationManager.error(
      error?.error || messages["errorMessage"],
      messages["error"],
      3000,
      null,
      null,
      "error"
    );
    dispatch(reset({ error: null }));
  }, [error]);

  useEffect(() => {
    if (!result) return;
    const messageSuccess = deleteDriverStatus
      ? messages["manage_deletedDriverStatus"]
      : messages["manage_deletedDriverStatusList"];
    NotificationManager.success(messageSuccess, messages["success"], 3000, null, null, "success");
    callback();
    dispatch(reset());
  }, [result]);

  return (
    <Modal
      title={
        deleteDriverStatus
          ? messages["manage_deleteDriverStatus"]
          : messages["manage_deleteDriverStatusList"]
      }
      size="small"
      open={open}
      handleClose={handleClose}
      loading={loading}
      footer={
        <div>
          <Button
            variant="secondary"
            style={{ marginRight: "5px" }}
            onClick={() => handleClose()}
            isDisabled={loading}
          >
            {messages["cancel"]}
          </Button>
          <Button variant="warning" onClick={() => handleDeleteSubmit()} isDisabled={loading}>
            {messages["delete"]}
          </Button>
        </div>
      }
    >
      <div style={{ padding: "10px 25px" }}>
        <p>{messages["manage_deleteManageDriverStatus_confirmationMessage"]}</p>
        <ul>
          {deleteDriverStatus ? (
            <li>{deleteDriverStatus?.name}</li>
          ) : (
            deleteDriverStatusList.map((driverStatus) => <li>{driverStatus.name}</li>)
          )}
        </ul>
      </div>
      <NotificationContainer />
    </Modal>
  );
};

export default DeleteManageDriverStatus;